import { selfGuidedTourSendPhoneCode, selfGuidedTourValidatePhoneCode } from 'constants/routes';
import { getAntiForgeryToken } from '../services/antiForgeryTokenService';

/**
 * Request a verification code to be sent to the user's phone.
 * @param specId
 * @param phone
 * @param email
 * @returns {Promise<any>}
 */
export function requestVerificationCode(specId, phone, email) {
  return fetch(selfGuidedTourSendPhoneCode, {
    method: 'POST',
    credentials: 'include',
    headers: {
      'Content-Type': 'application/json',
      'RequestVerificationToken': getAntiForgeryToken(),
    },
    body: JSON.stringify({ specId, phone, email }),
  })
    .then((response) => {
      if (!response.ok) {
        throw new Error('Network response was not ok');
      }
      return response.json();
    })
    .catch((error) => {
      throw error;
    });
}

/**
 * Verify the code entered by the user.
 * @param specId
 * @param phone
 * @param email
 * @param code
 * @returns {Promise<any>}
 */
export function requestVerifyCode(specId, phone, email, code) {
  return fetch(selfGuidedTourValidatePhoneCode, {
    method: 'POST',
    credentials: 'include',
    headers: {
      'Content-Type': 'application/json',
      'RequestVerificationToken': getAntiForgeryToken(),
    },
    body: JSON.stringify({ specId, phone, email, code }),
  })
    .then((response) => {
      if (!response.ok) {
        throw new Error('Network response was not ok');
      }
      return response.json();
    })
    .catch((error) => {
      throw error;
    });
}
